export default "__VITE_ASSET__Ckk2DLIT__"